<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Update User - {{ user.username }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="password"
          class="pb-20"
          label="password (leave blank for no change)"
          single-line
          @input="setUpdateDisabled"
        >
        </v-text-field>
        <v-text-field
          v-model="email"
          class="pb-20"
          label="email"
          single-line
          @input="setUpdateDisabled"
        >
        </v-text-field>
        <v-select
          v-model="role"
          :items="roleSelection"
          class="pb-20"
          label="role"
          @input="setUpdateDisabled"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="light-green" @click="onUpdateClick()" :disabled="updateDisabled">Update</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,

    user: Object,

    email: String,
    role: String,
  },

  data() {
    return {
      roleSelection: ['admin', 'engineer', 'support_lvl2', 'support', 'tech', 'ezadas', 'guest'],
      updateDisabled: true,

      password: '',
    };
  },

  methods: {
    setUpdateDisabled() {
      this.updateDisabled = !(
        this.password.length > 0
        || (this.role !== this.user.role && this.role.length > 0)
        || (this.email !== this.user.email && this.email.length > 0)
      );
    },

    onCancelClick() {
      this.updateDisabled = true;
      this.user = {};
      this.$emit('close', null);
    },

    onUpdateClick() {
      this.updateDisabled = true;

      this.$emit('close', {
        username: this.user.username, password: this.password, email: this.email, role: this.role, active: true,
      });

      this.username = '';
      this.password = '';
      this.email = '';
      this.role = '';
    },
  },
};
</script>
